import React from "react";
import { Heading } from "../../..//Heading";
export const StatsList = ({ years, description }) => (React.createElement("div", { className: "stats-list-root" },
    React.createElement(Heading, { design: "h3-bold" }, years),
    React.createElement("p", { className: "caption" }, description)));
